import changeCase from 'change-case'
import { array, bool, func, object } from 'prop-types'
import { Fragment, useState } from 'react'
import Button from '../../Button'
import CheckBox from '../../Inputs/CheckBox'
import TextArea from '../../Inputs/TextArea'
import { kuiperClassNames, renderIcon } from '../../utils'
import { styles } from './styles'

const ALT_TEXT_OPTION = 'asset alt text'

export const AssetOptions = ({
  asset,
  isLimitedUser,
  onSaveAssetOptions,
  options = [],
  updateCaption,
  updateCoverAsset,
}) => {
  const [optionValues, setOptionValues] = useState(() =>
    options.map((option) =>
      option.option === ALT_TEXT_OPTION
        ? { overrideEnabled: true, ...option }
        : option
    )
  )
  const [isSaveDisabled, setIsSaveDisabled] = useState(true)
  const getOptionIndex = (optionName) =>
    optionValues.findIndex((option) => option.option === optionName)

  const onOptionChange = (val, optionName) => {
    const newOptionValues = [...optionValues]
    const optionIndex = getOptionIndex(optionName)
    newOptionValues[optionIndex].content = val
    setOptionValues(newOptionValues)
    setIsSaveDisabled(false)
  }

  // The per-post alt text only overrides the asset's own alt text while the
  // checkbox is on; turning it off clears the override so the asset value wins.
  const onToggleOverride = (enabled, optionName) => {
    const newOptionValues = [...optionValues]
    const optionIndex = getOptionIndex(optionName)
    newOptionValues[optionIndex] = {
      ...newOptionValues[optionIndex],
      overrideEnabled: enabled,
      content: enabled ? newOptionValues[optionIndex].content : '',
    }
    setOptionValues(newOptionValues)
    setIsSaveDisabled(false)
  }

  const onSaveClick = () => {
    optionValues.map((option) => {
      if (option.option === ALT_TEXT_OPTION) {
        updateCaption(option.content, asset.id)
      }
      onSaveAssetOptions(optionValues)
      return option
    })
  }

  const onDownloadCoverAsset = (file) => {
    window.open(file, '_blank')
  }

  const onChangeCoverAsset = (data, optionName) => {
    const content = data ? { filename: data.files[0].name } : ''
    onOptionChange(content, optionName)
    updateCoverAsset(data)
  }

  return (
    <div style={styles.optionsWrapper}>
      <div style={styles.header}>Asset Options</div>
      {optionValues &&
        optionValues.map((option) => (
          <div key={option.option} style={styles.option}>
            <div style={styles.optionHeader}>
              {changeCase.sentenceCase(option.option)}
            </div>
            <div css={styles.optionInput}>
              {option.type === 'textarea' && (
                <Fragment>
                  {option.option === ALT_TEXT_OPTION && (
                    <div css={styles.overrideToggle}>
                      <CheckBox
                        ariaLabel="Override alt text for this post"
                        label="Override alt text for this post"
                        disabled={isLimitedUser}
                        value={option.overrideEnabled}
                        onChange={(val) => onToggleOverride(val, option.option)}
                      />
                    </div>
                  )}
                  <TextArea
                    ariaLabel="Asset Alt Text"
                    disabled={
                      isLimitedUser ||
                      (option.option === ALT_TEXT_OPTION &&
                        !option.overrideEnabled)
                    }
                    value={option.content || ''}
                    placeholder={option.assetAltText || ''}
                    theme="caption"
                    minRows={2}
                    maxRows={2}
                    onChange={(val) => onOptionChange(val, option.option)}
                  />
                </Fragment>
              )}
              {option.type === 'file' && (
                <div
                  css={styles.fileUploadStyle}
                  className={kuiperClassNames('cover-asset-upload')}
                >
                  {(option.content && option.content.filename) ||
                    'No file selected...'}
                  {option.content ? (
                    <div
                      className={kuiperClassNames('cover-asset-upload-buttons')}
                    >
                      <Button
                        ariaLabel="Download Asset"
                        icon="download"
                        iconOptions={{
                          width: 12,
                          height: 14,
                          ariaMode: 'hidden',
                        }}
                        type="invisible"
                        onClick={() =>
                          onDownloadCoverAsset(option.content.full_url)
                        }
                      />
                      <Button
                        ariaLabel="Remove Asset From Content"
                        disabled={isLimitedUser}
                        icon="close-sm"
                        iconOptions={{
                          width: 14,
                          height: 14,
                          ariaMode: 'hidden',
                        }}
                        type="invisible"
                        onClick={() => onChangeCoverAsset(null, option.option)}
                      />
                    </div>
                  ) : (
                    <div
                      className={kuiperClassNames('cover-asset-upload-buttons')}
                    >
                      <div
                        className={kuiperClassNames(
                          'asset-options-cover-asset-upload'
                        )}
                      >
                        <label htmlFor="kuiper-asset-options-file-input">
                          {renderIcon('upload', {
                            width: 12,
                            height: 14,
                            ariaMode: 'hidden',
                          })}
                        </label>
                        <input
                          aria-label="Video Asset Cover Image Upload"
                          id="kuiper-asset-options-file-input"
                          disabled={isLimitedUser}
                          type="file"
                          accept="image/*"
                          onChange={(ev) =>
                            onChangeCoverAsset(ev.target, option.option)
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        ))}
      <div style={styles.footer}>
        <Button
          ariaLabel="Save Asset Options"
          label="Save"
          disabled={isLimitedUser ? true : isSaveDisabled}
          onClick={onSaveClick}
        />
      </div>
    </div>
  )
}

AssetOptions.propTypes = {
  asset: object,
  isLimitedUser: bool,
  onSaveAssetOptions: func,
  options: array,
  updateCaption: func,
  updateCoverAsset: func,
}
